import React, { useEffect } from 'react';
import { Grid, ErrorMessage } from 'ui-toolkit';
import { PineconeThemeProvider } from 'ui-toolkit/theming/PineconeThemeProvider';
import { useSelector } from 'react-redux';
import {
  initAdminDocumentHistory,
  publishDocumentForHistory,
  unpublishDocumentForHistory,
} from '../../../store/order/documents/adminDocuments/dispatch';
import { eDocumentVisibilityType } from '../../../types/order/documents/eDocumentVisibilityType';
import { DocumentHistoryPage } from './DocumentHistoryPage';
import { RootStore } from '../../../store/types';
import { useSelectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { useParams } from 'react-router-dom';
import { isAmericanDigital } from '../../../utilities/order/hasAmericanDigitalUnderwriter';
import { useAppDispatch } from '../../../store/store';
import { useHasFeatureFlag } from '../../../selectors/useHasFeatureFlag';

export const DocumentHistoryContainer = () => {
  const { documentId } = useParams<{ orderId: string; documentId: string }>();
  const dispatch = useAppDispatch();
  const { documentHistory, documentsHistoryError, documentsError, documentsHistoryFetchStatus } = useSelector(
    (state: RootStore) => state.order.documents.adminDocuments
  );
  const { users, usersError, usersFetchStatus } = useSelector((state: RootStore) => state.usersCollection.allUsers);
  const { data } = useSelectCurrentOrder();
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');

  useEffect(() => {
    dispatch(initAdminDocumentHistory(documentId));
  }, [documentId, dispatch]);

  const pageError = documentsError || documentsHistoryError || usersError;
  const onPublishDocument = (documentId: string, versionId: string, visibilityType: eDocumentVisibilityType) =>
    dispatch(publishDocumentForHistory(documentId, versionId, visibilityType));
  const onUnpublishDocument = (documentId: string, versionId: string, visibilityType: eDocumentVisibilityType) =>
    dispatch(unpublishDocumentForHistory(documentId, versionId, visibilityType));

  return (
    <PineconeThemeProvider>
      <Grid>
        <ErrorMessage message={pageError} />
        <DocumentHistoryPage
          isAmericanDigital={isAmericanDigital(data)}
          documents={documentHistory[documentId] || []}
          dataLoading={documentsHistoryFetchStatus.fetching || usersFetchStatus.fetching}
          users={users}
          onUnpublish={onUnpublishDocument}
          onPublish={onPublishDocument}
          isZillowClosingEnabled={isZillowClosingEnabled}
        />
      </Grid>
    </PineconeThemeProvider>
  );
};
